import { memo } from 'react'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'
const config = process.env

const RegistrationCheck = memo(({ backToLogin }) => (
  <div className="registration-check">
    <Card className="registration-check__card" raised>
      <div className="registration-check__content">
        <Heading type="h2" secondary className="registration-check__header">
          Have you registered?
        </Heading>
        <Paragraph className="registration-check__content-text">
          Looks like you haven't registered for the Challenge yet. Please click
          the button below if you wish to do so!
        </Paragraph>
        <div className="registration-check__btn-wrap">
          <Button primary solid className="registration-check__btn-register">
            <a
              target="_blank"
              href={config.REACT_APP_CHALLENGE_REGISTER_URL}
              rel="noreferrer"
              className="registration-check__btn-register-link"
            >
              register now
            </a>
          </Button>

          <Button
            primary
            className="registration-check__btn-back-to-login"
            onClick={backToLogin}
          >
            back to log in
          </Button>
        </div>
      </div>
    </Card>
  </div>
))

export default RegistrationCheck
